module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.close),
      expression: "close"
    }],
    staticClass: "contenedor-interno"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('header', {
    staticClass: "card-header"
  }, [_c('p', {
    staticClass: "card-header-title"
  }, [_vm._t("title")], 2), _vm._m(0)]), _c('div', {
    staticClass: "card-content"
  }, [_vm._t("default", [_c('small', [_vm._v("Esta operación")]), _c('strong', [_vm._v("no se puede")]), _c('small', [_vm._v("revertir")]), _c('br')])], 2), _c('footer', {
    staticClass: "card-footer"
  }, [_c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": function($event) {
        return _vm.$emit('do')
      }
    }
  }, [_vm._t("primaryAction")], 2), _c('a', {
    staticClass: "card-footer-item",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancelar")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "card-header-icon"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-thumbs-up"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d663e24a","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Confirmar_Accion_Positioned.vue
// module id = 960
// module chunks = 0